import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Btn from "../../../../components/buttons/Btn";

const BtnMenu = ({
  btnLabel = "",
  startIcon,
  endIcon,
  fontSize = "",
  actions = [],
  disabled = false,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Btn
        startIcon={startIcon}
        endIcon={endIcon}
        label={btnLabel}
        fontSize={fontSize}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        disabled={disabled}
      />

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {actions.map((e, i) => (
          <MenuItem
            onClick={() => {
              e.onClick();
              handleClose();
            }}
            disabled={e.disabled}
            key={i}
          >
            {e.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default BtnMenu;
